import { useTheme } from "../../Utils/useTheme"

export const Switch = ({
  value = false,
  onChange,
  size = 44,
  minSize = 28
}: any) => {
  const { isDark } = useTheme()

  const width = Math.max(size, minSize)
  const height = Math.round(width * 0.55)
  const radius = height / 2
  const knobSize = height - 6
  const knobOffset = width - knobSize - 3

  return (
    <div
      onClick={() => onChange(!value)}
      style={{
        width,
        height,
        borderRadius: radius,
        background: value ? '#22c55e' : isDark ? '#374151' : '#d1d5db',
        position: 'relative',
        cursor: 'pointer',
        transition: 'background 160ms ease'
      }}
    >
      <div
        style={{
          width: knobSize,
          height: knobSize,
          borderRadius: '50%',
          background: '#fff',
          position: 'absolute',
          top: 3,
          left: value ? knobOffset : 3,
          transition: 'left 160ms cubic-bezier(.2,.8,.2,1)'
        }}
      />
    </div>
  )
}
